import { navImgAccess, navImgBeacon, navImgCamera, navImgIOT, navImgOS, navImgRTLS, navImgSensor, navImgWorld } from '@assets/images/nav';

export default {
  product: [
    {
      icon: navImgRTLS,
      title: 'ORBRO OS',
      link: '/jp/os',
      path: [
        { text: 'ORBRO サーバー', link: '/jp/os/server' },
        { text: 'ORBRO エッジ RTLS', link: '/jp/os/rtls' },
        { text: 'ORBRO エッジ AI', link: '/jp/os/ai' },
        { text: 'L2 スイッチ', link: '/jp/os/switch' },
      ],
    },
    {
      icon: navImgBeacon,
      title: '電波位置測位',
      link: '/jp/rtls',
      path: [
        { text: 'TwinTracker BLE', link: '/jp/rtls/ble' },
        { text: 'TwinTracker AoA', link: '/jp/rtls/aoa' },
        { text: 'TwinTracker UWB', link: '/jp/rtls/uwb' },
        { text: 'コンフォートキット', link: '/jp/rtls/comfort' },
      ],
    },
    {
      icon: navImgAccess,
      title: '映像位置測位',
      link: '/jp/camera',
      path: [
        { text: 'AI エッジ', link: '/jp/camera/edge' },
        { text: 'AI サーバー', link: '/jp/camera/server' },
      ],
    },

    {
      icon: navImgAccess,
      title: '屋外位置測位',
      link: 'none',
      path: [
        {
          text: 'GPS Device',
          link: '/jp/outdoor/gps',
        },
        {
          text: 'GPS Tag(LoRA)',
          link: '/jp/outdoor/lora',
        },
      ],
    },

    {
      icon: navImgSensor,
      title: '入退室システム',
      link: '/jp/access',
      path: [
        { text: 'Access Auto', link: '/jp/access/auto' },
        { text: 'Access Lite', link: '/jp/access/pro' },
        { text: 'Access アクセサリー', link: '/jp/access/accessory' },
      ],
    },
    {
      icon: navImgSensor,
      title: 'IIoT（産業用IoT）',
      link: '/jp/iot',
      path: [
        { text: 'LoRAセンサー', link: '/jp/iot/LoRASensor' },
        { text: 'CO₂測定器', link: '/jp/iot/co2' },
        { text: '空気質モニター', link: '/jp/iot/air' },
        { text: '非常ベル', link: '/jp/iot/bell' },
      ],
    },
    // {
    //   icon: navImgWorld,
    //   title: '連携システム',
    //   link: '/jp/integration',
    //   path: [{ text: 'ロボットシステム', link: '/jp/integration/robot' }],
    // },
  ],

  OS: {
    icon: navImgOS,
    title: 'ORBRO OS',
    desc: '入退室管理、リアルタイム位置測位、多様なIoT制御まで、ORBRO OSはスマートな空間を実現するためのあらゆる方法を統合したサービスです。今すぐスマートな未来を体験してください。',
    more: 'もっと見る',
    link: '/jp/os',
  },
  solution: [
    {
      title: '建設',
      path: [
        {
          text: '作業員の安全管理',
          link: '/enterprise/construction/safety',
        },
        {
          text: 'デジタルSOP管理',
          link: '/enterprise/construction/sop',
        },
        {
          text: 'クレーン安全管理',
          link: '/enterprise/construction/equipment',
        },
      ],
    },
    {
      title: 'スマートシティ',
      path: [
        {
          text: '都市災害デジタルツイン',
          link: '/enterprise/city/digitaltwin',
        },
        {
          text: '都市インフラデジタルツイン',
          link: '/digital-twin',
        },
        {
          text: '駐車場の車両追跡',
          link: '/enterprise/city/traffic',
        },
      ],
    },
    {
      title: '小売',
      path: [
        {
          text: 'スマートフォン展示セキュリティ管理',
          link: '/enterprise/retail/mobile',
        },
        {
          text: '展示会来場者分析',
          link: '/enterprise/retail/exhibition',
        },
        {
          text: 'オフィス資産管理',
          link: '/enterprise/retail/office',
        },
      ],
    },
    {
      title: '公共機関',
      path: [
        {
          text: '消防訓練位置追跡システム',
          link: '/enterprise/public/training',
        },
        {
          text: '交差点歩行者安全ソリューション',
          link: '/enterprise/public/crosswalk',
        },
        {
          text: '安心ベルシステム',
          link: '/enterprise/public/safety',
        },
      ],
    },
    {
      title: '製造',
      path: [
        {
          text: '鉄鋼物流自動管理',
          link: '/enterprise/manufacturing/steel',
        },
        {
          text: 'フォークリフト位置追跡',
          link: '/enterprise/manufacturing/forklift',
        },
        {
          text: '製造工程のリアルタイム管理',
          link: '/enterprise/manufacturing/process',
        },
      ],
    },
    {
      title: '物流',
      path: [
        {
          text: '倉庫資産追跡',
          link: '/enterprise/logistics/asset',
        },
        {
          text: 'コンテナ位置追跡',
          link: '/enterprise/logistics/manage',
        },
      ],
    },
    {
      title: '医療',
      path: [
        {
          text: '医療廃棄物ロボット管理',
          link: '/enterprise/medical/waste',
        },
        {
          text: '患者および医療機器の追跡',
          link: '/enterprise/medical/patient',
        },
      ],
    },
    {
      title: '学校',
      path: [
        {
          text: '校内の危険行動自動検出',
          link: '/enterprise/education/safety',
        },
      ],
    },
  ],
  world: {
    icon: navImgWorld,
    title: 'ORBRO デジタルツイン',
    desc: '現実世界の人・モノ・建物・都市のデータを受信し、デジタル空間でリアルタイムに監視・管理することができます。これにより、生産性の向上や問題の予防が可能となり、主に産業・製造分野で活用されています。',
    more: 'もっと見る',
    link: '/jp/digital-twin',
  },

  support: [
    {
      title: 'カスタマーサポート',
      path: [
        { text: '会社概要', link: '/jp/company' },
        { text: '営業お問い合わせ', link: '/jp/request' },
        { text: '代理店お問い合わせ', link: '/jp/partnership' },
        { text: 'ORBRO OS Guide', link: 'https://or-orbro-guide.gitbook.io/orbro-guide' },
      ],
    },
    {
      title: '技術紹介',
      path: [
        { text: 'UWB', link: '/jp/enterprise/technology/uwb' },
        { text: 'BLE', link: '/jp/enterprise/technology/ble' },
        { text: 'ステレオビジョン', link: '/jp/enterprise/technology/stereo-vision' },
        { text: 'モノキュラービジョン', link: '/jp/enterprise/technology/monocular-vision' },
        { text: 'TDoA', link: '/jp/enterprise/technology/tdoa' },
        { text: 'TWR', link: '/jp/enterprise/technology/twr' },
        { text: 'ジオフェンス', link: '/jp/enterprise/technology/what-is-geofence' },
        { text: 'デジタルツイン', link: '/jp/enterprise/technology/what-is-digital-twin' },
      ],
    },
    {
      title: 'ソフトウェア',
      link: 'new',
      path: [
        { text: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996' },
        { text: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile' },
        { text: 'ORBRO World', link: 'https://home.orbro.io' },
        { text: 'リリースノート', link: '/release-note' },
      ],
    },
    {
      title: 'ソーシャルメディア',
      link: 'new',
      path: [
        { text: 'LinkedIn', link: 'https://kr.linkedin.com/company/kongtech' },
        { text: 'Naver ブログ', link: 'https://blog.naver.com/orbro_platform' },
        { text: 'Medium', link: 'https://medium.com/@orbro' },
      ],
    },
  ],

  footerSupport: [
    {
      title: 'サポート',
      path: [
        { text: 'ブログ', link: '/jp/blog' },
        { text: '営業お問い合わせ', link: '/jp/request' },
        { text: '見積もり依頼', link: '/jp/pricing/1' },
        { text: '代理店お問い合わせ', link: '/jp/partnership' },
        { text: 'ORBRO OS Guide', link: 'https://or-orbro-guide.gitbook.io/orbro-guide' },
      ],
    },
    {
      title: 'ダウンロード',
      path: [
        { text: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996' },
        { text: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile' },
        { text: 'ORBRO World', link: 'https://home.orbro.io' },
        { text: 'リリースノート', link: '/release-note' },
      ],
    },
    {
      title: 'ソーシャルメディア',
      path: [
        { text: 'LinkedIn', link: 'https://kr.linkedin.com/company/kongtech' },
        { text: 'Naver ブログ', link: 'https://blog.naver.com/orbro_platform' },
      ],
    },
  ],
};
